import React from 'react';
import {
	Checkbox as AntdCheckbox,
	Flex,
} from 'antd';
import { CheckboxProps as AntdCheckboxProps } from 'antd/lib/index';
import styles from './Checkbox.module.css';

export type CheckboxProps = AntdCheckboxProps & {
	suffix?: React.ReactElement | string;
	suffixStyleProps?: React.CSSProperties;
	'data-testid'?: string;
};

const Checkbox = ({ suffix, suffixStyleProps, ...rest }: CheckboxProps) => {
	if (suffix) {
		const suffixContent = React.isValidElement(suffix) ?
			suffix :
			(
				<p
					className={styles.suffix}
					style={suffixStyleProps}
				>
					{suffix}
				</p>
			);

		return (
			<Flex gap={10}>
				<AntdCheckbox {...rest} />
				{suffixContent}
			</Flex>
		);
	}

	return (<AntdCheckbox {...rest} />);
};

export default Checkbox;
